module.exports = __webpack_public_path__ + "de878e54eca70cd458d088adeb23b2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/order_active.png
// module id = 739
// module chunks = 0